import ApiClientBase from "../core/ApiClientBase.js";
function isMutatingRequest(request) {
    return ["post", "put", "delete", "patch"].includes(request.method?.toLowerCase() ?? "");
}
function configureConsistencyHandlingInterceptor(axios) {
    let lastEventId = undefined;
    axios.interceptors.request.use((config) => {
        if (lastEventId !== undefined && !isMutatingRequest(config)) {
            config.headers["if-event-reached"] = lastEventId;
        }
        return config;
    });
    axios.interceptors.response.use((response) => {
        const headers = response.headers;
        if (headers.has("etag") && isMutatingRequest(response.config)) {
            lastEventId = headers.get("etag");
        }
        return response;
    });
}
export function withEventConsistencyHandling(clientOrAxiosInstance) {
    const axiosInstance = clientOrAxiosInstance instanceof ApiClientBase
        ? clientOrAxiosInstance.axios
        : clientOrAxiosInstance;
    configureConsistencyHandlingInterceptor(axiosInstance);
    return clientOrAxiosInstance;
}
